<template>
        <Layout :clientId='clientId' :channels='channels' :setTitle='title' :apiOrigin="apiOrigin">
        <div>
            <div class="article">
                <div class="searchText">
                    <input type="text" @keyup.13="getSearch" class="form-control" v-model="searchKey">
                    <img src="/public/w/img/pc/search-03.png" @click="getSearch" alt="">
                </div>
                <!-- 列表 开始 -->
                <publicList :list="newsList"></publicList>
                <a class="more" @click="more" :disabled="showMore == '加载中'" v-show="meta.cur_page<meta.total_page" href="javascript:;" id="pc-more">{{showMore?showMore:'加载更多'}}</a>
                <a class="more" v-show="meta.cur_page==meta.total_page" href="javascript:;" id="pc-more">没有更多了</a>
            </div>
            <!-- 列表 结束 -->
            <!-- 右侧列表开始 -->
            <div class="aside">
                <!--     <news-img-aside  title="热文"></news-img-aside> -->
                <newsImgAside title="热门新闻" :list="reWenList" :clientId="clientId"></newsImgAside>
            </div>
        </div>
    </Layout>

</template>
<style lang="css">
    @import "~asset/news-pc/css/css.css";
</style>
<script>
    import Layout from 'component/web/news-layout';
    import newsAside from 'component/web/news-aside/index';
    import swiper from 'component/web/swiper/swiper';
    import publicList from 'component/web/news-list/public-list';
    import newsImgAside from 'component/web/news-aside/img-aside';
    import axios from 'asset/news-pc/js/axios.js';
    import api from 'asset/news-pc/js/api.js';
    export default {
        components: {
            Layout,
            newsAside,
            publicList,
            swiper,
            newsImgAside
        },
        data() {
            return {
                page: 2,
/*                 pageList: [],
                newsList: [], */
                // reWenList: [],
            };
        },
        mounted() {

/*             axios.get(api.search).then(data => {
                this.newsList = data.data.data.items;
                this.pageList = data.data.data.items;
            });
            axios.get(api.rewen).then(data => {
                this.reWenList = data.data.data.items;
            }); */
        },
        methods: {
            getSearch() {
                const keywords = this.searchKey.replace(/ /g, '')
                axios.get(`${api.search}?keywords=${keywords}`).then(data => {
                    this.newsList = data.data.data.items;
                    this.pageList = data.data.data.items;
                    this.page = 2;
                });
            },
            more() {
                const keywords = this.searchKey.replace(/ /g, '')
                this.showMore = '加载中';
                axios.get(`${api.search}?page=${this.page}&keywords=${keywords}`).then(data => {
                    this.newsList = [...this.newsList, ...data.data.data.items];
                    this.meta = data.data.data._meta;
                    this.showMore = '加载更多';
                    this.page++;
                });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// app/web/page/news-pc/search.vue